import PropTypes from 'prop-types';
import { useEffect, type JSX } from 'react';

/** @internal */
export interface ComponentWithBodyClassProps {
  bodyClassName: string;
  bodyElement?: HTMLElement;
  children: JSX.Element;
}

type ForEachClassNameCallback = (className: string) => void;

const forEachClassName = (
  classNames: ComponentWithBodyClassProps['bodyClassName'],
  cb: ForEachClassNameCallback
) => {
  classNames
    .trim()
    .split(/\s+/)
    .forEach((className) => {
      cb(className);
    });
};
/**
 * Passes the child component through directly, while toggling
 * the body class according to the bodyClassName prop
 */
export default function ComponentWithBodyClass(
  props: ComponentWithBodyClassProps
) {
  const { bodyElement = document.body, bodyClassName, children } = props;

  useEffect(() => {
    forEachClassName(bodyClassName, (className) => {
      bodyElement.classList.add(className);
    });
    return () => {
      forEachClassName(bodyClassName, (className) => {
        bodyElement.classList.remove(className);
      });
    };
  }, [bodyClassName, bodyElement]);

  return children;
}

ComponentWithBodyClass.propTypes = {
  bodyClassName: PropTypes.string.isRequired,
  bodyElement: PropTypes.object,
  children: PropTypes.node,
};

ComponentWithBodyClass.displayName = 'ComponentWithBodyClass';
